<template>
  <LinkWrapper :href="event.eventUrl" target="_blank" @click="handleClick">
    <div :class="classes.columnWrapper">
      <div :class="[classes.textWrapper, layoutClass]">
        <DynamicText
          :id="teamNameFont"
          tag="p"
          styleGroup="Event Name"
          :get="fixtureNameStyle.get"
          :set="fixtureNameStyle.set"
        >
          {{ competitors[0].name.full }}
        </DynamicText>
      </div>
      <TeamVersusIcon
        :eventId="eventId"
        :class="classes.vs"
        v-bind="$attrs"
        :horizontalLine="true"
      />
      <div :class="[classes.textWrapper, layoutClass]">
        <DynamicText
          :id="teamNameFont"
          tag="p"
          styleGroup="Event Name"
          :get="fixtureNameStyle.get"
          :set="fixtureNameStyle.set"
        >
          {{ competitors[1].name.full }}
        </DynamicText>
      </div>
    </div>
  </LinkWrapper>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
import { injectBrand } from "@fresh8/ad-data-composition/src/brand";
import { Brand } from "@fresh8/types/src";
import TeamVersusIcon from "./TeamVersusIcon.vue";
import DynamicText from "./DynamicText.vue";
import LinkWrapper from "./LinkWrapper.vue";
import { createUseStyles } from "@fresh8/vue-jss/src";
import { injectCardNumber, useAnalytics } from "../hooks/useAnalytics";
import { composeEvent } from "@fresh8/ad-data-composition/src/betData";
import {
  awayFirstSports,
  orderedCompetitorData
} from "@fresh8/ad-data-composition/src/lib/orderedCompetitorData";
import {
  injectTemplateSize,
  SKYSCRAPER
} from "@fresh8/ad-data-composition/src/useTemplateSize";

const useStyles = createUseStyles({
  textWrapper: {
    height: "36px",
    width: "214px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    fontSize: "17px",

    [`&.${SKYSCRAPER.name}`]: {
      fontSize: "14px",
      height: "46px",
      width: "106px"
    }
  },
  vs: {
    fontSize: "12px",
    minHeight: "28px !important",
    maxHeight: "28px !important",
    minWidth: "104px !important",
    maxWidth: "104px !important",
    border: "none",
    padding: "unset"
  },
  columnWrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
  }
});

export default defineComponent({
  name: "Competitors",
  components: {
    DynamicText,
    LinkWrapper,
    TeamVersusIcon
  },
  props: {
    eventId: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const { marketBranding } = injectBrand();
    const cardNumber = injectCardNumber();
    const { handleClick } = useAnalytics(
      { ...props, cardNumber: cardNumber },
      "Event Name"
    );
    const layout = injectTemplateSize();
    const classesRef = useStyles();

    const event = composeEvent(props.eventId);
    const competitors = computed(() =>
      orderedCompetitorData(event.value.competitors, event.value.sport)
    );
    const vsText = computed(() =>
      awayFirstSports(event.value.sport) ? "@" : "vs"
    );
    return {
      classes: classesRef,
      handleClick,
      // Use the event name if home and away names don't exist
      useEventName: computed(
        () =>
          !(
            event.value?.competitors.away.name.short &&
            event.value?.competitors.home.name.short
          )
      ),
      fixtureNameStyle: {
        get: (brand: Brand) => brand.adTemplate.market.teamNameFont,
        set: (brand: Brand, value: string) =>
          (brand.adTemplate.market.teamNameFont = value)
      },
      competitors,
      tags: computed(
        () => competitors.value.map(item => item.name.micro) || []
      ),
      vsText,
      event,
      teamNameFont: computed(() => marketBranding.value?.teamNameFont || ""),
      layoutClass: computed(() => layout.size.value.name)
    };
  }
});
</script>

<style></style>
